class ComposeEmailHelper {
  window: Window;

  constructor() {
    this.window = window;
  }

  setWindow(newWindow: any) {
    this.window = newWindow;
  }

  getWindow() {
    return this.window;
  }

  focus() {
    if (this.window && this.window.focus) {
      this.window.focus();
    }
  }
}

export default new ComposeEmailHelper();
